<!-- Base dialog component that wraps the entire filter dialog -->
<dhp-filter-dialog [filterName]="filterName()">
  <div class="flex flex-col md:flex-nowrap md:gap-3">
    <div class="flex h-full w-full flex-col overflow-hidden">
      <!-- Header with selected count and clear button -->
      <dhp-filter-items-header
        [selectedCount]="selectedStrings().size"
        (clearSelection)="onClearSelection()"
      />

      <!-- Search bar component for filtering items -->
      @if (isSearchOptionEnabled()) {
        <dhp-filter-items-search-bar
          [placeholder]="filterName()"
          (searchTermOutput)="onSearchTermChange($event)"
        />
      }

      <!-- Items container with scroll functionality -->
      <div
        class="py-2.5, h-[350px] max-h-[350px] w-full overflow-x-hidden overflow-y-auto px-0"
      >
        <!-- Loading indicator -->
        @if (isLoading()) {
          <dhp-filter-items-loading />
        } @else {
          <!-- No Results -->
          @if (strings().size <= 0) {
            <dhp-filter-items-no-result />
          } @else {
            <!-- Render each item with a checkbox component -->
            @for (stringItem of strings(); track stringItem) {
              <dhp-filter-strings-checkbox
                [currentString]="stringItem"
                [isSelected]="isSelected(stringItem)"
                (selected)="onItemSelectedChange($event)"
              />
            }
          }
        }
      </div>
    </div>
  </div>
</dhp-filter-dialog>
